// OK - Error CORS
// import axios from "axios";
import Properties from "../properties";
import apiClient from "../plugins/axios-instance";

const API_URL =
  "https://backend." + Properties.DOMAIN_URL + "/merchant-api/api/merchants";


export default class MerchantAPIService {
  constructor() { }
  config = this.$session.get("jwt");

  static get = (limit, page) => {
    return apiClient.get(API_URL + "/limit/" + limit + "?page=" + page, {
    });
  };

  static edit = (id, merchant) =>
    apiClient.post(API_URL + "/" + id, merchant, {
    });

  static create = (merchant) =>
    apiClient.post(API_URL + "/", merchant, {
    });

  static delete = (kode, nik) =>
    apiClient.delete(API_URL + "/" + kode, {
      params: {
        user_update: nik,
      },
    });
}
